import { LectioJSUtils } from '../LectioJSUtils';
import { LCDocumentEditorUtils } from './LCDocumentEditorUtils';
import { ILectioPlugin } from './Types';

export class PluginLectioMobileToolbar implements ILectioPlugin {
	public Init(): void {
		CKEDITOR.plugins.add('lectiomobiletoolbar', {
			init: initPlugin,
		});
	}
}

type FeatureSet = {
	readonly cmd: string;
	readonly toolbarCssClass: string;
	shown: boolean;
}
const fsFormatting: FeatureSet = {
	cmd: 'lectiotoggleformatbuttons',
	toolbarCssClass: 'cke_toolbar_mobile_show_format',
	shown: false,
}

const fsInsert: FeatureSet = {
	cmd: 'lectiotoggleinsertbuttons',
	toolbarCssClass: 'cke_toolbar_mobile_show_insert',
	shown: false,
}


const initPlugin = (editor: CKEDITOR.editor): void => {
	if (editor.ui.addButton) {
		editor.ui.addButton('LectioToggleFormatButtons', {
			label: 'FMT',
			command: fsFormatting.cmd,
			// icon: CKEDITOR.skin.icons.newslide!.path,
			toolbar: '',
			className: 'cke_button_onlymobile'
		});
		editor.ui.addButton('LectioToggleInsertButtons', {
			label: 'INS',
			command: fsInsert.cmd,
			// icon: CKEDITOR.skin.icons.newslide!.path,
			toolbar: '',
			className: 'cke_button_onlymobile'
		});
	}

	editor.addCommand('lectiotoggleformatbuttons', {
		exec: (editor: CKEDITOR.editor) => {
			if (!editor)
				return false;

			fsFormatting.shown = !fsFormatting.shown;
			updateEditorFormatState(editor, fsFormatting);

			return true;
		},
	});
	editor.addCommand('lectiotoggleinsertbuttons', {
		exec: (editor: CKEDITOR.editor) => {
			if (!editor)
				return false;

			fsInsert.shown = !fsInsert.shown;
			updateEditorFormatState(editor, fsInsert);

			return true;
		},
	});

	// Soerg for at opdatere editoren med den delte tilstand.
	editor.on('focus', evt => {
		updateEditorFormatState(editor, fsFormatting);
		updateEditorFormatState(editor, fsInsert);
	});
	editor.on('instanceReady', evt => {
		const following = 4;
		const preceding = 2;

		// marker knapper/grupper, der skal vises afhaengigt af mobil og toggle af mobilknapper.
		const tb = LCDocumentEditorUtils.GetToolbarObject(evt.editor)[0];
		const toolGroupsEx = tb.querySelectorAll('.cke_combo, .cke_toolgroup');
		const firstBreak = tb.querySelector('.cke_toolbar_break');
		LectioJSUtils.AssertNotNullOrUndefined(firstBreak, 'fistBreak');

		const formatThings = toolGroupsEx.filter((ele, idx) => idx >= 4 && ele.compareDocumentPosition(firstBreak) & following)
		$(formatThings).addClass('cke_toolbar_mobile_format');

		const insertParent = toolGroupsEx.first(ele => ele.compareDocumentPosition(formatThings.last()) & preceding);
		const insertThings = insertParent.querySelectorAll(':scope > *').filter((_, idx) => idx >= 2);
		$(insertThings).addClass('cke_toolbar_mobile_insert');
	})
};

const updateEditorFormatState = (editor: CKEDITOR.editor, fs: FeatureSet) => {
	const cmd = editor.getCommand(fs.cmd);
	cmd.setState(fs.shown ? CKEDITOR.TRISTATE_ON : CKEDITOR.TRISTATE_OFF);

	const tb = LCDocumentEditorUtils.GetToolbarObject(editor)[0];
	const them = tb.querySelector('.cke_toolbox')!;
	if (fs.shown)
		them.classList.add(fs.toolbarCssClass);
	else
		them.classList.remove(fs.toolbarCssClass);
}